import { Dialog } from '@mui/material';
import React, { useState } from 'react';

import EnhancedTab from '../../../../../../../../../lib/designSystem/TabSimulation';
import FilesDialog from '../../../../../common/filesView';
import CessionMain from './components/CessionMain';
import Summary from './components/Summary';

const ShoppingDialogSent = (props: any) => {
  const {
    shoppingCartType,
    openShoppingCart,
    setOpenShoppingCart,
    setUp,
    openRequest,
    setOpenRequest,
    setSuccessOpen,
    setFailureOpen,
    operationDate,
    setOperationDate,
  } = props;
  const [openFiles, setOpenFiles] = useState(false);
  const startValue = 0;

  const tabs = [
    {
      index: 0,
      label: 'Resumen',
      component: (
        <Summary
          shoppingCartType={shoppingCartType}
          openShoppingCart={openShoppingCart}
          setOpenShoppingCart={setOpenShoppingCart}
          setUp={setUp}
          openRequest={openRequest}
          setOpenRequest={setOpenRequest}
          setSuccessOpen={setSuccessOpen}
          setFailureOpen={setFailureOpen}
          operationDate={operationDate}
          setOperationDate={setOperationDate}
        />
      ),
    },
    {
      index: 1,
      label: 'Archivos ',
      component: (
        <FilesDialog
          openRequest={openRequest}
          openFiles={openFiles}
          requestType="factoring"
          setOpenFiles={setOpenFiles}
          setSuccessOpen={setSuccessOpen}
          setFailureOpen={setFailureOpen}
          setOpenShoppingCart={setOpenShoppingCart}
        />
      ),
      path: 'recieved',
    },
    // {
    //   index: 2,
    //   label: 'Chat',
    //   component: (
    //     <ChatWindow
    //       requestType="factoring"
    //       selectedRequest={openRequest}
    //       setSuccessOpen={setSuccessOpen}
    //       setFailureOpen={setFailureOpen}
    //     />
    //   ),
    //   path: 'recieved',
    // },
    {
      index: 3,
      label: 'Cesión',
      component: (
        <CessionMain
          selectedRequest={openRequest}
          setOpenShoppingCart={setOpenShoppingCart}
          setSuccessOpen={setSuccessOpen}
          setFailureOpen={setFailureOpen}
        />
      ),
      disabled: ['Creada', 'Rechazada'].includes(openRequest?.status),
      path: 'cession',
    },
  ];

  return (
    <div>
      <Dialog
        maxWidth="md"
        fullWidth
        open={openShoppingCart}
        onClose={() => setOpenShoppingCart(false)}
      >
        <div style={{ padding: 20, minHeight: 200 }}>
          <EnhancedTab
            title={
              openRequest ? `Solicitud #${openRequest?.id}` : 'Nueva solicitud'
            }
            startValue={startValue}
            tabs={tabs}
            closeAction={() => setOpenShoppingCart(false)}
          />
        </div>
      </Dialog>
    </div>
  );
};

export default ShoppingDialogSent;
